<template>
  <section>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@40,400,0,0"
    />
    <!-- Boton acutualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            dialog = dialog ? false : true;
          }
        "
        color="#007681"
        dark
        slot="activator"
        ><span class="material-symbols-outlined"> calendar_month </span
        >CALENDARIO
      </v-btn>
      <span>Calendario de vacaciones</span>
    </v-tooltip>
    <!-- DIALOG CALENDARIO -->
    <v-dialog v-model="dialog" persistent width="1000">
      <v-card>
        <v-toolbar color="#007681" dark>
          <span class="material-symbols-outlined"> calendar_month</span>
          <v-toolbar-title
            style="font-family: Century Gothic, CenturyGothic, AppleGothic, sans-serif;"
            >Calendario de vacaciones</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- Cuerpo del formulario -->
        <v-card-text>
          <v-flex xs12>
            <Transition name="slide-fade">
              <v-div class="div-color">
                  <v-btn block style="background-color:#9FAEE5 ;" class="letra">
                    Pendiente aprob. uso
                  </v-btn>
                  <v-btn block style="background-color:#C5E86C ;" class="letra">
                    Aprobado uso vacación
                  </v-btn>
              </v-div>
            </Transition>
          </v-flex>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs12>
                <v-sheet height="700">
                  <v-calendar
                    ref="calendar"
                    v-model="start"
                    type="month"
                    :end="end"
                    :value="today"
                    color="primary"
                    locale="es"
                  >
                    <template v-slot:day="{ date }">
                      <v-card v-for="event in eventsMap[date]" :key="event.id">
                        <v-menu v-model="event.open" full-width offset-x>
                          <template v-slot:activator="{ on }">
                            <div
                              v-if="!event.time"
                              :class="
                                event.estado == 7
                                  ? 'permiso-aprobado'
                                  : 'permiso-rechazado'
                              "
                              :style="`background-color: ${event.color};`"
                              v-on="on"
                              v-html="event.title"
                            ></div>
                          </template>
                          <v-card color="grey lighten-4" min-width="350px" flat>
                            <v-toolbar color="primary" dark>
                              <v-btn icon>
                                <v-icon>edit</v-icon>
                              </v-btn>
                              {{ event.title }}

                              <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-title primary-title>
                              <span v-html="event.details"></span>
                            </v-card-title>
                            <v-card-actions>
                              <v-btn flat color="blue"> Cerrar </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>
                      </v-card>
                    </template>
                  </v-calendar>
                </v-sheet>
              </v-flex>
              <v-flex shrink>
                <v-btn @click="$refs.calendar.prev()">
                  <v-icon dark left> keyboard_arrow_left </v-icon>
                  Anterior
                </v-btn>
                <v-btn @click="$refs.calendar.next()">
                  Siguiente
                  <v-icon right dark> keyboard_arrow_right </v-icon>
                </v-btn></v-flex
              >
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> CERRAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      user: this.$storage.get("user"),
      dialog: false,
      // -----------------------CALENDARIO---------------------------
      start: this.$moment().format("YYYY-MM-DD"),
      end: this.$moment().format("YYYY-MM-DD"),
      today: this.$moment().format("YYYY-MM-DD"),
      events: [],
      mapa_colores: new Map()
    };
  },
  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    }
  },
  async mounted() {
    await this.cargarVacacionesProgramadas();
  },

  methods: {
    close() {
      this.dialog = false;
    },
    open(event) {
      alert(event.title);
    },
    async cargarVacacionesProgramadas() {
      try {
        this.loading = true;
        let resp = await this.$service.graphql({
          query: `
          query{
            vVacacionReprogramadaYParaUsoJerarquicos(id_jefe:${this.user.id_persona},lista_estados:"55,56,57,58,65"){
              rows {
                id_jefe
                nombres
                estado
                id_estado
                gestion
                id_persona
                id_vacacion_programada
                fecha_desde
                fecha_hasta
                total_dias
                secuencia
                id_unidad
                bandera
                dias_faltantes
                nro_doc
                nro_item
                fecha_solicitud
                nombre_unidad
                tipo
                id_estado_hijo
                justificacion
              }
            }
          }
        `
        });
        let lista_tmp = resp.vVacacionReprogramadaYParaUsoJerarquicos.rows;
        let lista_fechas = [];
        // Obtneniendo el rango de fechas en results
        var diasEntreFechas = function(desde, hasta) {
          var dia_actual = desde;
          var fechas = [];
          while (dia_actual.isSameOrBefore(hasta)) {
            fechas.push(dia_actual.format("YYYY-MM-DD"));
            dia_actual.add(1, "days");
          }
          return fechas;
        };
        for (let i = 0; i < lista_tmp.length; i++) {
          const element = lista_tmp[i];
          let desde = this.$moment(
            element.fecha_desde
              .split("/")
              .reverse()
              .join("-")
          );
          let hasta = this.$moment(
            element.fecha_hasta
              .split("/")
              .reverse()
              .join("-")
          );
          let feriados = await this.obtieneFeriadosPersona(element.id_persona);
          let results = diasEntreFechas(desde, hasta);
          //Recorriendo las fechas para ir creando los eventos
          this.mapa_colores.set(22, "#FAE053");
          this.mapa_colores.set(22, "#EFBE7D");
          this.mapa_colores.set(51, "#C09C83");
          this.mapa_colores.set(73, "#FF9E1B");
          this.mapa_colores.set(66, "#FFA3B5");
          this.mapa_colores.set(54, "#E93CAC");
          this.mapa_colores.set(72, "#AC4FC6");
          this.mapa_colores.set(55, "#69B3E7");
          this.mapa_colores.set(58, "#9FAEE5");
          this.mapa_colores.set(65, "#C5E86C");
          this.mapa_colores.set(56, "#F3EA5D");
          this.mapa_colores.set(57, "#9B945F");
          this.mapa_colores.set(67, "#B7B09C");
          this.mapa_colores.set(68, "#B2B4B2");
          this.mapa_colores.set(69, "#E59E6D");
          this.mapa_colores.set(70, "#7A4183");
          for (let index = 0; index < results.length; index++) {
            const fecha = results[index];
            // Validamos fines de semana
            var feha = new Date(fecha);
            var dayOfWeek = feha.getDay();
            if (dayOfWeek !== 5 && dayOfWeek !== 6) {
              const found = feriados.find(element => element.fecha == fecha);
              if (!found) {
                let evento = {
                  id: element.id_vacacion_programada,
                  title: element.nombres,
                  details: `<b>ESTADO:</b>${element.estado}<br><b>TOTAL DIAS:</b>${element.total_dias}`,
                  date: fecha,
                  open: false,
                  estado: element.estado,
                  color: this.mapa_colores.get(element.id_estado)
                };
                lista_fechas.push(evento);
              }
            }
          }
        }
        this.events = lista_fechas;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async obtieneFeriadosPersona(id_persona) {
      try {
        let res = await this.$service.graphql({
          query: `query{
            vFeriadoFuncionarios(id_persona:${parseInt(id_persona)}){
              rows{
                id_persona
                nro_item
                fecha
                nacional
              }
            }
          }
					`
        });
        res = res.vFeriadoFuncionarios.rows;
        return res;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.letra {
  font-size: calc(0.5em + 0.5vw);
  line-height: 5em;
  padding: 0em;
  margin: 0em;
  height: 1em;
  width: 12em;
}
.div-color {
  vertical-align: top;
  text-align: center;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/components/CalendarioVacaciones.vue